import { Select, MenuItem, Typography, FormHelperText } from "@mui/material";
import * as TextVariables from "../../../assets/Variables/TextVariables.js";
import Colors from "../../../assets/Variables/ColorsVariables.js";
import { Spaces } from "../../../assets/Variables/SpaceVariables.js";

const SelectorSimple = ({
  title,
  value,
  handleChange,
  options,
  error,
  helperText,
  placeholder,
  name,
}) => {
  const selectStyle = {
    fontFamily: "Plus Jakarta Sans, sans-serif",
    width: 141, // según diseño
    backgroundColor: Colors.Gray_50,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.MuiOutlinedInput-root": {
      borderRadius: Spaces.Size_2,
      border: error
        ? `1px solid ${Colors.Error_700}`
        : `1px solid ${Colors.Secondary_700}`,
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 8px",
      height: 36,
      boxSizing: "border-box",
      fontFamily: "Plus Jakarta Sans, sans-serif",
      fontWeight: 400,
      fontSize: "12px",   // Overline / Overline‑1
      lineHeight: 1.2,    // 120 %
      color: Colors.Secondary_600,
    },
  };

  const labelTextStyle = {
    marginRight: "10px",
    marginBottom: "5px",
    marginTop: "-16px", // pequeño ajuste para alinearlo con los otros campos
    fontFamily: "Plus Jakarta Sans, sans-serif",
    fontWeight: 400,
    fontSize: "12px", // Caption / Caption‑2
    lineHeight: 1.4,  // 140 %
    color: Colors.Secondary_700,
  };

  const placeholderTextStyle = {
    fontFamily: "Plus Jakarta Sans, sans-serif",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: 1.2,
    color: Colors.Gray_400,
  };

  const menuItemTextStyle = {
    fontFamily: "Plus Jakarta Sans, sans-serif",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: 1.2,
    color: Colors.Secondary_600,
  };

  const helperTextStyle = {
    color: error ? Colors.Error_700 : Colors.Gray_500,
    fontFamily: TextVariables.Body_4,
    fontSize: "12px",
    marginTop: "4px",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: "-4px", // sube ligeramente todo el bloque para alinearlo
      }}
    >
      <Typography variant="caption" sx={labelTextStyle}>
        {title}
      </Typography>

      <Select
        value={value}
        onChange={handleChange}
        sx={selectStyle}
        inputProps={{ name }}
        displayEmpty
      >
        <MenuItem value="" disabled>
          <Typography sx={placeholderTextStyle}>
            {placeholder}
          </Typography>
        </MenuItem>

        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            <Typography sx={menuItemTextStyle}>
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>

      {error && (
        <FormHelperText sx={helperTextStyle}>
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
};

export default SelectorSimple;